
export class GamePropertiesVO {
    public showTooltip: number = 0;
    public ignoreBuddyRequest: number = 0;
    public playSound: number = 0;
    public isSpec: number = 0;

    constructor() {
    }
}
